import { CompanyProjectPropertiesService } from '@beeboard/common';
import { defineStore } from 'pinia';
import type {
  CompanyProjectProperty,
  CreateCompanyProjectProperty,
  UpdateCompanyProjectProperty,
} from '@beeboard/common';

export type CustomPropertiesStoreState = {
  companyProjectProperties: CompanyProjectProperty[];
};

export const useCustomPropertiesStore = defineStore('customPropertiesStore', {
  state: (): CustomPropertiesStoreState => ({
    companyProjectProperties: [] as CompanyProjectProperty[],
  }),

  getters: {
    hasCustomProperties(state): boolean {
      return state.companyProjectProperties.length > 0;
    },
  },

  actions: {
    write(property: CompanyProjectProperty) {
      const properties = this.$state.companyProjectProperties;
      const oldProperty = properties.find((p) => p.id === property.id);
      if (oldProperty) {
        Object.assign(oldProperty, property);
      } else {
        properties.push(property);
      }
    },

    async loadCompanyProjectProperties() {
      const response =
        await CompanyProjectPropertiesService.getCompanyProjectProperties();
      this.$patch({ companyProjectProperties: response.items });
    },

    async create(payload: CreateCompanyProjectProperty) {
      const property =
        await CompanyProjectPropertiesService.createCompanyProjectProperty(
          payload,
        );
      this.write(property);
    },

    async update(propertyId: string, payload: UpdateCompanyProjectProperty) {
      const property =
        await CompanyProjectPropertiesService.updateCompanyProjectProperty(
          propertyId,
          payload,
        );
      this.write(property);
    },

    async delete(propertyId: string, force = false) {
      await CompanyProjectPropertiesService.deleteCompanyProjectProperty(
        propertyId,
        force,
      );
      const properties = this.$state.companyProjectProperties;
      const propertyIndex = properties.findIndex((p) => p.id === propertyId);
      if (propertyIndex > -1) {
        properties.splice(propertyIndex, 1);
      }
    },
  },
});
